import script from "./SentMessageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SentMessageDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import EmptyState from "@/components/neue/EmptyState.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import RowLink from "@/components/neue/RowLink.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SmartListLinks from "@/components/neue/SmartListLinks.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
script.components = Object.assign({}, { EmptyState, NeueLoading, NeueTablist, NeueWell, RowLink, SecondaryNav, SecondaryTop, SmartListLinks, TablistGrid, TablistHeader, TablistRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { EmptyState, NeueLoading, NeueTablist, NeueWell, RowLink, SecondaryNav, SecondaryTop, SmartListLinks, TablistGrid, TablistHeader, TablistRow }, script.__o.components);}